import { useQuery } from '@tanstack/react-query';

import {
  AdminAcquisitionInsightsParams,
  AdminAcquisitionInsightsResponse,
  getAdminAcquisitionInsights,
} from '@/services/api/admin';

export const ADMIN_ACQUISITION_INSIGHTS_QUERY_KEY = ['admin', 'acquisition-insights'];

export const useAdminAcquisitionInsights = (params: AdminAcquisitionInsightsParams = {}) => {
  const query = useQuery<AdminAcquisitionInsightsResponse>({
    queryKey: [...ADMIN_ACQUISITION_INSIGHTS_QUERY_KEY, params],
    queryFn: () => getAdminAcquisitionInsights(params),
    staleTime: 5 * 60 * 1000,
  });

  return {
    insights: query.data ?? null,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
    isFetching: query.isFetching,
  };
};
